<aside class="tv-facts-panel" *ngIf="tvDetails">

  <!-- Header -->
  <div class="facts-header">
    <div class="facts-header-left">
      <div class="header-icon-box">
        <i class="fas fa-circle-info"></i>
      </div>
      <div>
        <h3 class="facts-title">Series Facts</h3>
        <span class="facts-subtitle">Quick Show Overview</span>
      </div>
    </div>
  </div>

  <!-- Key Metrics Highlights Grid -->
  <div class="facts-metrics-grid">
    <!-- Rating Card -->
    <div class="metric-card rating-card" *ngIf="tvDetails?.vote_average">
      <div class="metric-top">
        <i class="fas fa-star rating-star"></i>
        <span class="metric-label">Rating</span>
      </div>
      <div class="metric-value">
        <span class="rating-num">{{ tvDetails?.vote_average | number:'1.1-1' }}</span>
        <span class="rating-denom">/10</span>
        <span class="vote-count" *ngIf="tvDetails?.vote_count">({{ tvDetails?.vote_count | number }} votes)</span>
      </div>
    </div>

    <!-- Seasons Card -->
    <div class="metric-card" *ngIf="tvDetails?.number_of_seasons">
      <div class="metric-top">
        <i class="fas fa-layer-group metric-icon"></i>
        <span class="metric-label">Seasons</span>
      </div>
      <span class="metric-value">{{ tvDetails?.number_of_seasons }}</span>
    </div>

    <!-- Episodes Card -->
    <div class="metric-card" *ngIf="tvDetails?.number_of_episodes">
      <div class="metric-top">
        <i class="fas fa-list-ol metric-icon"></i>
        <span class="metric-label">Episodes</span>
      </div>
      <span class="metric-value">{{ tvDetails?.number_of_episodes }}</span>
    </div>
  </div>

  <!-- Tagline Block (if exists) -->
  <div class="facts-tagline" *ngIf="tvDetails?.tagline">
    <i class="fas fa-quote-left quote-mark"></i>
    <p class="tagline-quote">{{ tvDetails?.tagline }}</p>
  </div>

  <!-- Structured Details Rows -->
  <div class="facts-rows-list">
    <!-- Type -->
    <div class="fact-row" *ngIf="tvDetails?.type">
      <div class="fact-row-header">
        <i class="fas fa-tv"></i>
        <span>Show Type</span>
      </div>
      <span class="fact-row-content">{{ tvDetails?.type }}</span>
    </div>

    <!-- First Air Date -->
    <div class="fact-row" *ngIf="tvDetails?.first_air_date">
      <div class="fact-row-header">
        <i class="fas fa-calendar-alt"></i>
        <span>Original Premiere</span>
      </div>
      <span class="fact-row-content">{{ tvDetails?.first_air_date | date:'MMMM d, yyyy' }}</span>
    </div>

    <!-- Last Air Date -->
    <div class="fact-row" *ngIf="tvDetails?.last_air_date">
      <div class="fact-row-header">
        <i class="fas fa-calendar-check"></i>
        <span>Last Air Date</span>
      </div>
      <span class="fact-row-content">{{ tvDetails?.last_air_date | date:'MMMM d, yyyy' }}</span>
    </div>

    <!-- Episode Runtime -->
    <div class="fact-row" *ngIf="tvDetails?.episode_run_time?.length || tvDetails?.runtime">
      <div class="fact-row-header">
        <i class="fas fa-clock"></i>
        <span>Episode Runtime</span>
      </div>
      <span class="fact-row-content">
        {{ tvDetails?.episode_run_time?.[0] || tvDetails?.runtime }} minutes
      </span>
    </div>

    <!-- Language -->
    <div class="fact-row" *ngIf="tvDetails?.original_language">
      <div class="fact-row-header">
        <i class="fas fa-language"></i>
        <span>Original Language</span>
      </div>
      <span class="fact-row-content language-badge">
        {{ getLanguageName(tvDetails?.original_language) }}
        <span class="code-pill">({{ tvDetails?.original_language | uppercase }})</span>
      </span>
    </div>

    <!-- Production Countries -->
    <div class="fact-row" *ngIf="tvDetails?.production_countries?.length">
      <div class="fact-row-header">
        <i class="fas fa-earth-americas"></i>
        <span>Origin Country</span>
      </div>
      <div class="fact-row-content">
        <span *ngFor="let country of tvDetails?.production_countries; let last = last">
          {{ country?.name }}<span *ngIf="!last">, </span>
        </span>
      </div>
    </div>

    <!-- Networks -->
    <div class="fact-block" *ngIf="tvDetails?.networks?.length">
      <div class="fact-row-header">
        <i class="fas fa-broadcast-tower"></i>
        <span>Original Network</span>
      </div>
      <div class="networks-container">
        <div class="network-badge" *ngFor="let net of tvDetails?.networks">
          <img *ngIf="net.logo_path" [src]="'https://image.tmdb.org/t/p/w200' + net.logo_path" [alt]="net.name"
            class="network-logo" (error)="onImageError($event)">
          <span class="network-name">{{ net.name }}</span>
        </div>
      </div>
    </div>

    <!-- Genres -->
    <div class="fact-block" *ngIf="tvDetails?.genres?.length">
      <div class="fact-row-header">
        <i class="fas fa-tags"></i>
        <span>Genres</span>
      </div>
      <div class="pills-container">
        <span class="info-pill genre-pill" *ngFor="let genre of tvDetails?.genres">
          {{ genre.name }}
        </span>
      </div>
    </div>

    <!-- Production Companies -->
    <div class="fact-block" *ngIf="tvDetails?.production_companies?.length">
      <div class="fact-row-header">
        <i class="fas fa-building"></i>
        <span>Production</span>
      </div>
      <div class="pills-container">
        <span class="info-pill company-pill" *ngFor="let company of tvDetails?.production_companies">
          {{ company.name }}
        </span>
      </div>
    </div>

    <!-- Official Website Action Button -->
    <div class="website-action" *ngIf="tvDetails?.homepage">
      <a [href]="tvDetails?.homepage" target="_blank" rel="noopener noreferrer" class="website-link-btn">
        <i class="fas fa-arrow-up-right-from-square"></i>
        <span>Visit Official Website</span>
      </a>
    </div>
  </div>
</aside>